import React from 'react';
import IconDetails from '../common/IconDetails';
import Border from '../common/border';
import ActivityTitle from '../common/ActivityTitle';
import { NeedToKnow } from '@/types/activityDetailsTypes';

interface KeyDetailsProps {
  details: NeedToKnow[];
}
const KeyDetails: React.FC<KeyDetailsProps> = ({ details }) => {
  if (!details || details.length === 0) {
    return null; // Don't render if there's no data
  }

  return (
    <div className='mt-8'>
      <ActivityTitle title='What should I know' className='' />
      <div className='grid xl:grid-cols-4 lg:grid-cols-3 md:grid-cols-2 grid-cols-2 gap-6 mb-8 pt-2 w-full'>
        {details.map((detail, index) => (
          <div key={index} className='h-full'>
            <IconDetails
              title={detail.title}
              desc={detail.description}
              src={detail.imageUrl || detail.icon}
              className='w-5 h-5'
            />
          </div>
        ))}
      </div>

      <Border />
    </div>
  );
};

export default KeyDetails;
